/**
 * The ServiceGateway API
 * The ServiceGateway provides APIs to interact with the Gintel Easy Business Communications Suite (EBCS)
 *
 * OpenAPI spec version: 1.14.31-SNAPSHOT
 * Contact: frank.paaske@gintel.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface SipTerminal { 
    oname?: string;
    login?: string;
    fullNumber?: string;
    sipUser?: string;
    sipPassword?: string;
    sipDomain?: string;
    pin?: string;
    blocked?: boolean;
    clientType?: number;
    uuid?: string;
    agent?: string;
    macAddress?: string;
    sipPhoneVendorName?: string;
    sipPhoneModelName?: string;
}
